import jwtDecode from "jwt-decode";

import * as Constants from "../../config/constants/Constants.js";
import { getLanguage } from "../../config/language/language.js";
import { getFetch, postFetch, catchAPIResponse, catchAPIError } from "./http.js";

export const sessionExpired = (props) => {
    props.user.setUserJWT("");
    props.user.setUserRole("");
    props.user.setIsLoggedIn(false);
    props.roles.setIsAdmin(false);
    props.showSnackbar({ color: "warning", message: getLanguage().SNACKBAR_SESSION_EXPIRED });
    props.browser.navigate("/login");
};

export const logUserOut = (props) => {
    props.user.setUserJWT("");
    props.user.setUserRole("");
    props.user.setIsLoggedIn(false);
    props.roles.setIsAdmin(false);
    props.browser.navigate("/login");
};

export const queryAuthStatus = (props) => {
    getFetch(Constants.API_AUTH_STATUS, props.user.userJWT)
        .then((response) => {
            if (response.ok) {
                props.auth.setAuthStatus(response.body);
                props.server.setIsConnectionToServerEstablished(true);

                const requiresLogin = response.body?.requiresLogin;
                const hasToken = Boolean(props.user.userJWT);

                if (requiresLogin && !hasToken) {
                    const path = props.browser.location?.pathname || "";
                    if (path !== "/login") {
                        props.browser.navigate("/login");
                    }
                }
            } else {
                catchAPIResponse(props, response);
            }
        })
        .catch((err) => catchAPIError(props, err));
};

export const loginWithPassword = async (props, password, role) => {
    const response = await postFetch(Constants.API_LOGIN_PATH, { password, role }, null);
    if (!response.ok) {
        catchAPIResponse(props, response);
        return false;
    }

    const token = response.body.access_token;
    const tokenRole = response.body.role || role;

    props.user.setUserJWT(token);
    props.user.setUserRole(tokenRole);
    props.user.setIsLoggedIn(true);
    props.roles.setIsAdmin(tokenRole === "admin");
    props.showSnackbar({ color: "success", message: getLanguage().SNACKBAR_SUCCESS_LOGIN });
    props.browser.navigate("/");
    queryAuthStatus(props);
    return true;
};

export const applyRoleFromJwt = (props) => {
    const jwt = props.user.userJWT;
    if (!jwt) {
        props.roles.setIsAdmin(false);
        return;
    }
    try {
        const decoded = jwtDecode(jwt);
        const role = decoded.role || "";
        props.user.setUserRole(role);
        props.roles.setIsAdmin(role === "admin");
        props.user.setIsLoggedIn(true);
    } catch (e) {
        console.warn("Failed to decode JWT", e);
    }
};
